import React from "react";
import ReactDOM from "react-dom";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import App from "./app/App";
import NotificationsToaster from "./components/NotificationsToaster/NotificationsToaster";
import "./index.css";
import { store, persistor } from "./redux/store";
import * as serviceWorker from "./serviceWorker";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import { createRoot } from "react-dom/client";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <HelmetProvider>
        <FluentProvider theme={webLightTheme}>
          <App />
        </FluentProvider>
      </HelmetProvider>
      <NotificationsToaster />
    </PersistGate>
  </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
